var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiscordGradient = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.796875 30.7393V70.4238C0.796929 72.2345 1.2994 74.0134 2.2538 75.5814C3.2082 77.1497 4.58092 78.4518 6.23396 79.3572L42.4612 99.1995C44.1143 100.105 45.9896 100.582 47.8983 100.582C49.8072 100.582 51.6822 100.105 53.3354 99.1995L89.5627 79.3572C91.2158 78.4518 92.5884 77.1497 93.5429 75.5814C94.4974 74.0134 94.9998 72.2345 94.9998 70.4238V30.7393C94.9998 28.9286 94.4974 27.1497 93.5429 25.5817C92.5884 24.0134 91.2158 22.7112 89.5627 21.8059L53.3354 1.96358C51.6822 1.05819 49.8072 0.581543 47.8983 0.581543C45.9896 0.581543 44.1143 1.05819 42.4612 1.96358L6.23396 21.8059C4.58092 22.7112 3.2082 24.0134 2.2538 25.5817C1.2994 27.1497 0.796929 28.9286 0.796875 30.7393Z",
    fill: "#4375C5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96228 74.5417L3.96221 74.5415C3.19577 73.2823 2.79692 71.8624 2.79688 70.4238V30.7393C2.79688 30.7393 2.79688 30.7393 2.79688 30.7393C2.79693 29.3006 3.19578 27.8807 3.96221 26.6215L3.96228 26.6214C4.72933 25.361 5.84061 24.3016 7.19471 23.56L6.23396 21.8059L7.19472 23.56L43.4219 3.71773C44.7766 2.97577 46.3209 2.58154 47.8983 2.58154C49.4759 2.58154 51.0199 2.97576 52.3747 3.71773L88.6019 23.56L88.602 23.56C89.9561 24.3016 91.0673 25.361 91.8345 26.6215L91.8345 26.6216C92.601 27.8807 92.9998 29.3006 92.9998 30.7393V70.4238C92.9998 71.8625 92.601 73.2824 91.8345 74.5415L91.8345 74.5416C91.0673 75.8021 89.9561 76.8614 88.6019 77.6031L52.3746 97.4454C51.0199 98.1874 49.4759 98.5815 47.8983 98.5815C46.3209 98.5815 44.7766 98.1874 43.422 97.4454L7.19478 77.6031C7.19476 77.6031 7.19474 77.6031 7.19472 77.6031C5.84056 76.8613 4.7293 75.802 3.96228 74.5417Z",
    stroke: "url(#paint0_linear_13440_32898)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6233 38.268C58.1727 37.1237 55.595 36.2979 52.9363 35.8496C52.6011 36.4513 52.2197 37.2653 51.9538 37.9141C49.1333 37.4894 46.2551 37.4894 43.4346 37.9141C43.1341 37.2063 42.7989 36.522 42.429 35.8496C39.7703 36.3097 37.1811 37.1237 34.7305 38.2798C29.8756 45.6648 28.5578 52.8728 29.2167 59.9747C32.0603 62.1336 35.2507 63.7734 38.6491 64.8351C39.412 63.7734 40.094 62.6644 40.672 61.4847C39.5738 61.06 38.5104 60.541 37.4932 59.9393C37.759 59.7388 38.0133 59.5264 38.2561 59.3259C44.2322 62.2044 51.1562 62.2044 57.1208 59.3259C57.3751 59.5382 57.641 59.7506 57.8953 59.9393C56.878 60.5528 55.8146 61.0718 54.7049 61.4965C55.2829 62.6644 55.9649 63.7852 56.7278 64.8351C60.1262 63.7852 63.3166 62.1454 66.1601 59.9747C66.923 51.7521 64.8308 44.6031 60.6117 38.2798L60.6233 38.268ZM41.4927 55.6098C39.6547 55.6098 38.1405 53.8874 38.1405 51.7757C38.1405 49.664 39.6201 47.9299 41.4927 47.9299C43.3653 47.9299 44.8564 49.6522 44.8449 51.7639C44.8333 53.8756 43.3653 55.6098 41.4927 55.6098ZM53.8726 55.6098C52.0347 55.6098 50.5205 53.8874 50.5205 51.7757C50.5205 49.664 52 47.9299 53.8726 47.9299C55.7452 47.9299 57.2364 49.6522 57.2248 51.7639C57.2133 53.8756 55.7452 55.6098 53.8726 55.6098Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13440_32898",
    x1: 0.796873,
    y1: 0.342359,
    x2: 115.389,
    y2: 63.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4195D2",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiscordGradient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discord_gradient.4b0ffe076a8704d0b42ac8b57c10f403.svg";